module.exports = __webpack_public_path__ + "static/img/cygn2.eb7cffc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newestqianniu/cygn2.png
// module id = 311
// module chunks = 0